module.exports = __webpack_public_path__ + "img/d2hk_SL.86d7356e.svg";